import type { ApiResponse } from '@klaro7/shared-types';

import api from '@/lib/api';

export interface ResendConfirmationResult {
  resendInSeconds: number;
}

export async function confirmEmail(token: string): Promise<void> {
  await api.post('/auth/confirm-email', { token });
}

export async function resendConfirmationEmail(): Promise<ResendConfirmationResult> {
  const res = await api.post<ApiResponse<ResendConfirmationResult>>('/auth/resend-confirmation-email');
  return res.data.data;
}
